import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-sales-phone-enrollment-manual-questions-process-datacultr',
  templateUrl: './sales-phone-enrollment-manual-questions-process-datacultr.component.html',
  styles: [ ]
})
export class SalesPhoneEnrollmentManualQuestionsProcessDatacultrComponent {
  qrCode = '';
  visibleModalEndProcess = false;
  visibleModalQRProcess = true;

  @Output() step = new EventEmitter();
  @Input() request: any;
  @Input() phoneEnrollmentData: any;

  ngOnInit() {
    console.log(this.phoneEnrollmentData);
    this.qrCode = this.phoneEnrollmentData?.nuovo?.qr_code_data;
  }

  onReturnEnrollment(){
    this.step.emit('init-enrollment-datacultr');
  }

  onProgressEnrollment(){
    this.step.emit('in-progress');
  }

  get isManual(){
    return this.request?.enrollment_type === 'manual';
  }

}
